import { TableCellRenderer } from "react-table";

import * as globalTableColumns from "src/core/shared/components/TableGlobalColumns";
import { CustomTableColumn } from "src/library/components/Tables/Table";

export const leadTimeSettingsColumns = (scope: "customer" | "branch", ActionButton: TableCellRenderer): CustomTableColumn[] => {
  return [
    globalTableColumns.id(),
    globalTableColumns.standardText({
      Header: `${scope === "customer" ? "Acc." : "Branch"} Number`,
      accessor: scope === "customer" ? "customer.accountNumber" : "branch.branchNumber",
      sortable: false
    }),
    globalTableColumns.standardText({
      Header: "Name",
      accessor: `${scope}.name`,
      sortable: false
    }),
    globalTableColumns.standardText({
      Header: "Cutoff",
      accessor: "value.time",
      sortable: false
    }),
    globalTableColumns.actions({ cell: ActionButton })
  ];
};
